export default "__VITE_PUBLIC_ASSET__319fd85f__"